import { REDIRECT_STATUS_CODES } from 'src/constants/common';
import { _404Redirect, _redirectToOtherRoute } from './404Redirect';
import { getRoute } from './routes';

export const PDP_ROUTE_IDENTIFIER = '/product/';

/**
 * function for returing product page path following domain.
 * sample product url - "httts://wwww.domain.com/product/remaining_string"
 * then this would return "/product/remaining_string" or "product/remaining_string" depending on the value of startWithSlash.
 * @param productUrl - product link received from backend.
 * @param startWithSlash - tells us whether to start the Path with "/" or not.
 * @returns - path of product following domain - "/product/remaining_string"
 */
export function getProductPathFromUrl(
  productUrl: string,
  startWithSlash: boolean = true
) {
  const splittedArray = productUrl?.split(PDP_ROUTE_IDENTIFIER);
  if (splittedArray?.length > 1) {
    const route = PDP_ROUTE_IDENTIFIER + splittedArray[1];
    return startWithSlash ? route : route?.slice(1);
  } else {
    return '';
  }
}

interface IProductResponse {
  error: {
    response?: {
      status: number;
      data?: {
        data?: string;
      };
    };
  };
}

interface IPropTypes {
  ssrStore?: {
    storeReducer?: {
      store?: {
        domain: string;
      };
    };
  };
}

interface IErrorCaseHandler {
  ctx: any;
  productResponse: IProductResponse;
  propType: IPropTypes;
}

/**
 * This function handles the redirection for pdp page on server side in case of error while fetching product data.
 * if the status code id 3XX - it redirects to new product Url
 * else it would redirect to 404 - Not Fund page.
 * @param {*} ctx
 * @param {*} productResponse
 * @param {*} propType
 */
export function handlePDPErrorCaseRedirection({
  ctx,
  productResponse,
  propType,
}: IErrorCaseHandler) {
  const statusCode = productResponse?.error?.response?.status;
  if (REDIRECT_STATUS_CODES.includes(statusCode)) {
    const productItem = JSON.parse(productResponse?.error?.response?.data?.data);
    const newProductPath = getProductPathFromUrl(productItem?.link, false);
    const domainFromStore = propType?.ssrStore?.storeReducer?.store?.domain;
    _redirectToOtherRoute(
      ctx,
      statusCode,
      getRoute(newProductPath, domainFromStore, ctx)
    );
  } else {
    _404Redirect(ctx);
  }
}
